const PACKING_LIST_STATUSES = {
  accepted: "accepted",
  waitingShipment: "waiting_shipment"
};

export { PACKING_LIST_STATUSES };